var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-screen',{staticClass:"screen-bsi theme-bsi",scopedSlots:_vm._u([{key:"branding",fn:function(){return [_c('strong',[_vm._v("Bibliothèque des sciences et de l'industrie")])]},proxy:true}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }